import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DELIVERY_CASH_UNITELLER } from 'apps/auth/constants/Constants';
import { LimitsService } from 'apps/auth/services/LimitsService';

import ExceedTransactionLimit from './ExceedTransactionLimit';
import ViewPopup from './ViewPopup';

const ThreeMonthsPopup = ({
    popupRef,
    defaultDecreaseAmountButtonClick,
    decreaseAmountButtonClick,
    value,
    maxAmount,
    messages,
    extra,
    isTransactionalLimits,
    isFrom,
    deliveryMethod,
}) => {
    const { profile, canMakeDraftTransaction, hasOtherDeliveryOption, leftLimitAmount, additionalAmlLimit } = extra;
    const { isExceedNumberTransactions, isZeroRemainingProfileLimits } = LimitsService.getThreeMonthLimitsError(
        { maxAmount, value, canMakeDraftTransaction },
        profile,
    );
    const isProfileLimits = !!(leftLimitAmount && maxAmount && leftLimitAmount < maxAmount);
    const isAdditionalSendingLimits = additionalAmlLimit && value > additionalAmlLimit.left;
    const isZeroAdditionalLimits = additionalAmlLimit && LimitsService.getZeroAdditionalLimitsErrors(value, additionalAmlLimit);

    const isShowChangePickupButton = deliveryMethod === DELIVERY_CASH_UNITELLER && isTransactionalLimits;
    const isShowDeliveryOptions = hasOtherDeliveryOption && isTransactionalLimits && !isAdditionalSendingLimits;
    const getErrorText = () => {
        if (isExceedNumberTransactions) {
            return <DangerouslyHtml dangerouslyHtml={messages.errorTextThreeMonthTransfers} />;
        } else if (isZeroRemainingProfileLimits || isProfileLimits) {
            return <DangerouslyHtml dangerouslyHtml={messages.errorTextThreeMonthLimit} />;
        } else if (isAdditionalSendingLimits) {
            return <DangerouslyHtml dangerouslyHtml={isFrom ? messages.additionalLimitErrorText : messages.errorTextAdditionalLimitLeftAmount} />;
        } else {
            return (
                <ExceedTransactionLimit
                    isFrom={isFrom}
                    isShowDeliveryOptions={isShowDeliveryOptions}
                    isShowChangePickupButton={isShowChangePickupButton}
                    messages={messages}
                />
            );
        }
    };

    return (
        <ViewPopup
            isShowChangeAmountButton={!isExceedNumberTransactions && !isZeroRemainingProfileLimits && !isZeroAdditionalLimits}
            isShowGotItButton={false}
            isShowDeliveryOptions={isShowDeliveryOptions}
            isShowIncreaseLimitButton={isProfileLimits || isZeroRemainingProfileLimits || isExceedNumberTransactions}
            isShowChangePickupButton={isShowChangePickupButton}
            deliveryMethod={deliveryMethod}
            defaultDecreaseAmountButtonClick={defaultDecreaseAmountButtonClick}
            decreaseAmountButtonClick={decreaseAmountButtonClick}
            popupRef={popupRef}
            errorText={getErrorText()}
            profile={profile}
            messages={messages}
            arrowButtonText={messages.upgradeLimitButton}
        />
    );
};
ThreeMonthsPopup.propTypes = {
    defaultDecreaseAmountButtonClick: PropTypes.func,
    decreaseAmountButtonClick: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    value: PropTypes.number,
    maxAmount: PropTypes.number,
    messages: PropTypes.object,
    isTransactionalLimits: PropTypes.bool,
    extra: PropTypes.object,
    deliveryMethod: PropTypes.string,
};
export default ThreeMonthsPopup;
